import { Link } from 'react-router-dom';
import { Home, FileText, Palette, Settings, Zap, Blocks } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import WidgetShell from '../WidgetShell';

/**
 * Always-on widget (no featureFlag/siteTypes) so the dashboard is never empty
 * for a brand-new tenant with no data yet. Links target sections available on
 * every site type (Content + Settings nav groups are ungated).
 */
const ACTIONS: { label: string; to: string; icon: LucideIcon }[] = [
  { label: 'Homepage', to: '/admin/homepage', icon: Home },
  { label: 'Pages', to: '/admin/pages', icon: FileText },
  { label: 'Theme', to: '/admin/settings/theme', icon: Palette },
  { label: 'Settings', to: '/admin/settings', icon: Settings },
  { label: 'Apps', to: '/admin/apps', icon: Blocks },
  { label: 'Features', to: '/admin/feature-toggles', icon: Zap },
];

export default function QuickActionsWidget() {
  return (
    <WidgetShell title="Quick Actions" icon={<Zap />}>
      <div className="grid grid-cols-3 gap-2">
        {ACTIONS.map(({ label, to, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="flex flex-col items-center gap-1.5 rounded-lg border border-line p-3 text-center text-xs font-medium text-stone-600 transition-colors hover:border-green-200 hover:bg-green-50 hover:text-green-800"
          >
            <Icon className="h-5 w-5" aria-hidden="true" />
            {label}
          </Link>
        ))}
      </div>
    </WidgetShell>
  );
}
